import styled from 'styled-components';
import { Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
    max-height: 90vh;
    
    @media (max-width: 465px) {
      margin: 16px;
      width: calc(100% - 32px);
      max-height: calc(100vh - 32px);
    }
  }
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-blue, #0B4598);
  margin: 0;
  padding-right: 40px;
  
  @media (max-width: 465px) {
    font-size: 1.25rem;
  }
`;

export const ModalDescription = styled.p`
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
  margin: 0 0 16px 0;
  
  @media (max-width: 465px) {
    font-size: 0.9rem;
    margin: 0 0 12px 0;
  }
`;

export const ModalContent = styled.div`
  padding: 0;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
  
  @media (max-width: 465px) {
    margin-top: 16px;
  }
`;

export const SuccessMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--success-main, #13CA82);
  text-align: center;
  
  @media (max-width: 465px) {
    padding: 30px 15px;
    font-size: 1rem;
  }
`; 